import React from 'react'

const CheckmarkSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="12"
    viewBox="0 0 11 12"
  >
    <g>
      <g>
        <path
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="20"
          strokeWidth="2"
          d="M1.69 7.63v0l3.342 2.73v0L9.363 1.6v0"
        />
      </g>
    </g>
  </svg>
)

export default CheckmarkSVG
